import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent, trackPage } from '@/utils/analytics';
import { EventType } from '@/types/analytics';

export function NavigationTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page views
    trackPage(location.pathname, {
      path: location.pathname,
      referrer: document.referrer,
      title: document.title
    });

    trackEvent(EventType.PAGE_VIEWED, {
      path: location.pathname,
      referrer: document.referrer,
      title: document.title
    });
  }, [location]);

  return null; // This is a tracking component, no UI needed
}

export function ExternalLinkTracker({ href, children, ...props }) {
  const handleClick = (e) => {
    // Track external link clicks
    trackEvent(EventType.EXTERNAL_LINK_CLICKED, {
      url: href,
      text: typeof children === 'string' ? children : undefined,
      referrer: window.location.href
    });
  };

  return (
    <a href={href} onClick={handleClick} {...props}>
      {children}
    </a>
  );
} 